import {ApiResource} from 'common/util/model-resource/api-resource';
import {ProjectMember} from 'common/types/app-api/project-member';

import {projectUsersClient} from '../queries/app-api/project-users-client';

export class ProjectUsersResource extends ApiResource<ProjectMember> {
  apiClient = projectUsersClient;
}
